import { createLightTheme } from "../../utils/createLightTheme.js";
import { brandTeams } from "../../global/brandColors.js";
export const teamsLightTheme = createLightTheme(brandTeams);
